const BLACK_FRIDAY = {
  CATEGORY_NAME: 'Black Friday',
  LANDING_TYPE: 'BLACK_FRIDAY',
};

export default BLACK_FRIDAY;
